import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParentItemProviderService } from '@app/shared';
import { UIComponents, log, Util, NtapGlobalConstants } from '@ntap/core';
import { Subscription, combineLatest } from 'rxjs';

@Component({
  selector: 'app-datoteke-lista',
  templateUrl: './datoteke-lista.component.html',
  providers: [ParentItemProviderService]
})
export class DatotekeListaComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = UIComponents.LISTVIEW;

  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};

  parentItem: any;

  routeChangeSubscription: Subscription;

  @Input()
  viewName = 'datoteke';

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ParentItemProviderService
  ) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = combineLatest([
      this.route.paramMap,
      this.parentItemProvider.parentItem$
    ]).subscribe(([, parentItem]: [params: any, parentItem: any]) => {
      log('param change');
      this.parentItem = parentItem;
      this.changeView(this.viewName, parentItem);
    });
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      $parentId:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ],
      $itemType: 'en~pojavni_oblik',
      $parentType: parentItem[NtapGlobalConstants.ATTR_$mainType],
      $parent: parentItem
    };
    this.currentListViewStateFilter = {};
  }
}
